// extracted by css-extract-rspack-plugin
export default {"buttons":"JkvLo","pwa_button_override":"ICTcb","pwaButtonOverride":"ICTcb","#":"klDiw"};